type SetupOptions = {
	environment: string
	version: string
}

declare global {
	interface Window {
		aabAnalyticsGlobal: Record<string, string | number>
		aabAnalytics: Array<{
			command: 'ADD EVENT'
			name: 'pageview'
			data: {
				page_url: string
				page_language: string
				page_name_route: string
				page_channel: string
				form_id?: string
				form_name?: string
				form_type?: string
				form_step_name?: string
				form_step_id?: string
				form_session_id?: string
				form_context?: string
				form_outcome?: string
				form_status?: 'end-success' | 'end-fail'
			}
		}>
	}
}

export type PageviewOptions = {
	locale: string
	pageName: string
	form?: {
		id: string
		name: string
		type: string
		stepName: string
		stepId: string
		sessionId: string
		context?: string
		outcome?: string
		status?: 'end-success' | 'end-fail'
	}
}

export const abnTrackingCreate = ({ environment, version }: SetupOptions) => {
	window.aabAnalyticsGlobal = {
		app_platform: 'iframe',
		app_name: 'car insurance comparison',
		app_environment: environment === 'prod' ? 'prod' : 'dev',
		app_version: version,
		app_organisation: 'ABN AMRO',
		app_country_code: 'nl',
		app_business_line: 'retail',
		app_oar: 'AAB.SYS.016991',
		app_client_unit: 'personal and business banking',
		app_business_segment: 'personal',
	}
	window.aabAnalytics = []

	const script = document.createElement('script')
	script.src = 'https://www.abnamro.nl/nl/retail/pr/static/aab-vendor/analytics/deq/aab-analytics-body.js'
	document.body.append(script)

	return {
		logPageview: ({ locale, pageName, form }: PageviewOptions) => {
			window.aabAnalytics.push({
				command: 'ADD EVENT',
				name: 'pageview',
				data: {
					page_url: location.href,
					page_language: locale,
					page_name_route: pageName,
					page_channel: 'open domain',
					form_id: form?.id,
					form_name: form?.name,
					form_type: form?.type,
					form_step_name: form?.stepName,
					form_step_id: form?.stepId,
					form_session_id: form?.sessionId,
					form_context: form?.context,
					form_outcome: form?.outcome,
					form_status: form?.status,
				},
			})
		},
	}
}

export type AbnTracking = ReturnType<typeof abnTrackingCreate>
